// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../../core/reducers';
import {
  selectDoctorsInStore,
  selectDoctorsPageLoading,
  selectDoctorsShowInitWaitingMessage,
} from '../_selectors/doctor.selectors';

export class DoctorsDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectDoctorsPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(select(selectDoctorsShowInitWaitingMessage));

    this.store.pipe(select(selectDoctorsInStore)).subscribe((response: QueryResultsModel) => {
      this.paginatorTotalSubject.next(response.totalCount);
      this.entitySubject.next(response.items);
    });
  }
}
